import { render, staticRenderFns } from "./RegisterCountByTypeStatisticsPage.vue?vue&type=template&id=4d2461da&scoped=true&"
import script from "./RegisterCountByTypeStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./RegisterCountByTypeStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2461da",
  null
  
)

export default component.exports